import * as types from "./types";

export const defaultState = {
  product: null,
  show_modal: false,
  page: 1,
  group_type: 'public',
  created_circle: null
};

const b2b_button = (state = defaultState, action) => {
  switch (action.type) {
    case types.ADD_PRODUCT:           
      return {
        ...state,
        product: action.product,
    }
    case types.UPDATE_PRODUCT:           
      return {
        ...state,
        product: {...state.product, ...action.update}
      }
    case types.TOGGLE_BUY_MODAL:           
      return {
        ...state,
        show_modal: action.status
    }
    case types.NEXT_PAGE:           
      return {
        ...state,
        page: action.page?action.page:state.page+1
    }
    case types.PREVIOUS_PAGE:           
      return {
        ...state,
        page: action.page?action.page:state.page-1
    }
    case types.SET_GROUPE_TYPE:           
      return {
        ...state,
        group_type: action.group_type
    }
    case types.SAVE_NEW_CIRCLE_DETAILS:
      return {
        ...state,
        created_circle: action.circle
      }
    case types.REMOVE_PRODUCT:           
      return defaultState
    default:
      return state;
  }
};
export default b2b_button;
